import React from 'react';
import styled from 'styled-components';
import { DirectionalMeasurementDimension } from '@kentik/ui-shared/query/query.types';
import { Button, Flex, Text } from 'core/components';

const DirectionButton = styled(Button)`
  &.bp4-button {
    font-weight: 500;
    height: 20px;
    min-height: auto;
    font-size: 10px;
    box-shadow: none;
  }

  &.select-directionality-active {
    opacity: 0.3;
  }

  &.select-directionality-selected {
    background-color: ${({ theme }) => theme.colors.primary};
    color: white;
    font-weight: 600;

    &:hover {
      filter: brightness(0.9);
    }
  }
`;

const DirectionalButtons = (props: {
  label: string;
  directions: DirectionalMeasurementDimension['Directions'];
  onSelect?: (dimensionKey: string) => void;
  matches?: { name: string }[];
  highlightSelected?: boolean;
}) => {
  const { label, directions, onSelect, matches = [], highlightSelected = false } = props;

  return (
    <Flex alignItems="center" gap={1} flex={1}>
      <Text textAlign="left" small flex={1}>
        {label}
      </Text>
      <Flex alignItems="center" gap="2px" flexShrink={0}>
        {Object.entries(directions)
          .sort(([a]) => (a === 'src' ? -1 : 1))
          .map(([dirKey, contents]) => {
            const buttonText = dirKey === 'dst' ? 'DEST' : 'SRC';
            const isActive = matches.some((m) => m.name === contents.key);
            const activeClass = highlightSelected ? 'select-directionality-selected' : 'select-directionality-active';
            const className = isActive ? `select-directionality ${activeClass}` : 'select-directionality';

            return (
              <DirectionButton
                key={contents.key}
                data-dimension={contents.key}
                onClick={(e) => {
                  e.stopPropagation();
                  if (onSelect && contents.key) {
                    onSelect(contents.key);
                  }
                }}
                className={className}
                small
                text={buttonText}
              />
            );
          })}
      </Flex>
    </Flex>
  );
};

export default DirectionalButtons;
